import { useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';
import { Timeout } from 'types/enums';

export const useMutationObserver = (
    node: Node,
    callback: () => void,
    mutationType: MutationRecordType = 'childList',
    options: MutationObserverInit = {
        attributes: true,
        childList: true,
        subtree: true,
    },
): void => {
    const observer = useMemo(
        () =>
            new MutationObserver((mutationList, observer) => {
                for (const mutation of mutationList) {
                    if (mutation.type === mutationType) {
                        debounce(callback, Timeout.base, {
                            leading: true,
                            maxWait: 2000,
                        })();
                    }
                }
            }),
        [callback, mutationType],
    );

    useEffect(() => {
        if (node) {
            observer.observe(node, options);
            return (): void => {
                observer.disconnect();
            };
        }
    }, [node, options, observer]);
};
